module.exports = __webpack_public_path__ + "static/media/building_color.30df125d.svg";